module.exports = __webpack_public_path__ + "static/media/image7.ca1d6546.png";